import {
	StyledContainer,
	StyledPowerButton,
	StyledSeam,
	StyledVolumeButton,
} from './PhoneCase.styled';

const PhoneCase = () => (
	<StyledContainer>
		<StyledVolumeButton $top={160} />
		<StyledVolumeButton $top={240} />
		<StyledPowerButton />
		<StyledSeam $left={0} />
		<StyledSeam $left={404} />
	</StyledContainer>
);

export { PhoneCase };
